import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { ISbRichtext, renderRichText } from '@storyblok/js';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-company-logo-list',
  standalone: true,
  templateUrl: './company-logo-list.component.html',
  styleUrls: ['./company-logo-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, BlockWrapperComponent, StoryblokCdnPipe],
})
export class CompanyLogoListComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() companies: {
    logo: StoryblokImage;
    rating: number;
    dimensions: { width: number; height: number };
  }[];
  @Input() contentAbove: ISbRichtext;
  @Input() showRating: boolean;
  @Input() style: BlockStyle[];
  contentAboveHtml: string;

  ngOnChanges() {
    this.style = this.style || [];
    this.contentAboveHtml = this.contentAbove ? renderRichText(this.contentAbove) : undefined;

    this.companies.forEach(company => {
      company.dimensions = this.getLogoDimensions(company.logo);
    });
  }

  getLogoDimensions(logo: StoryblokImage) {
    const url = logo.filename; // "https://a.storyblok.com/f/234504/96x48/75a96f3294/parship.jpg"
    const dimensionString = url.match(/\/\d+x\d+\//)?.[0]; // "/96x48/"
    const dimensions = dimensionString?.match(/\d+/g); // ["96", "48"]
    const width = parseInt(dimensions?.[0]); // "96"
    const height = parseInt(dimensions?.[1]); // "48"
    return { width, height };
  }

  getStars(count: number) {
    if (!count) count = 5;
    return Array(5)
      .fill(0)
      .map((_, i) => {
        const _i = i + 1;
        if (_i >= count + 1) return 'star-empty';
        if (_i <= count) return 'star-filled';
        return 'star-half';
      });
  }
}
